import { render, staticRenderFns } from "./req.vue?vue&type=template&id=510163e6&scoped=true&"
import script from "./req.vue?vue&type=script&lang=js&"
export * from "./req.vue?vue&type=script&lang=js&"
import style0 from "./req.vue?vue&type=style&index=0&id=510163e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510163e6",
  null
  
)

export default component.exports